import type { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export const PlusIcon = ({ className }: { className?: HTMLAttributes<SVGElement>["className"] }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={twMerge("fill-black dark:fill-white", className)}
        >
            <path d="M3 6H11V8H3V6Z" />
            <path d="M8 3L8 11L6 11L6 3L8 3Z" />
        </svg>
    );
};
